import styled from 'styled-components';
import { Breakpoints } from '@01_people/ui-library';

export default styled.div`
  span.svg-icon {
    &--checked {
      svg {
        rect {
          fill: #346ffe;
        }
        g > g > g {
          fill: #346ffe;
        }
      }
    }
  }

  h5.twofa-heading {
    margin-bottom: 14px;
  }

  .two-fa-form {
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: space-between;
    /* min-height: 465px; */

    .label-wrapper {
      width: 290px;
      max-height: 190px;
      height: 100%;
      margin-bottom: 45px;

      &:nth-child(2),
      &:nth-child(4) {
        margin-right: 0;
      }

      span:nth-child(1) {
        /* font-family: 'Roboto Condensed', sans-serif; */
        line-height: 1.2;
      }

      .svg-wrapper {
        margin-bottom: 16px;
      }
    }
  }

  @media (max-width: ${Breakpoints.maxSmall}) {
    .two-fa-form {
      display: flex;

      .twofa-toggle {
        margin-left: 0;
        margin-top: 18px;
      }

      .label-wrapper {
        max-width: 144px;

        & > div:nth-child(2) {
          max-width: 157px;

          span {
            font-size: 14px;
            font-weight: normal;
            &:nth-child(1) {
              font-weight: bold;
              color: #182445;
            }
            &:nth-child(2) {
              margin-top: 4px;
              color: ${({ theme }) => theme.colors.gray.color};
            }
          }
        }
      }
    }
  }

  @media (max-width: 339.9px) {
    .two-fa-form {
      flex-direction: column;

      .label-wrapper {
        max-width: 100%;
        max-height: none;

        .twofa-toggle {
          max-width: none !important;
        }
      }
    }
  }
`;
